// Import Vue and the icon Vue component
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import all needed icons, add them here if new icons are needed
import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Import light icons here
// import { faLongArrowRight as falLongArrowRight } from '@fortawesome/pro-light-svg-icons';

// Import regular icons here
// import { faMegaphone as farMegaphone } from '@fortawesome/pro-regular-svg-icons';

// Import solid icons here
// import { faSignIn as fasSignIn } from '@fortawesome/pro-solid-svg-icons';

// Import duotone icons here
import { faCow as fadCow } from '@fortawesome/pro-duotone-svg-icons';
import { faSquareFull as fadSquareFull } from '@fortawesome/pro-duotone-svg-icons';
import { faCheckCircle as fadCheckCircle } from '@fortawesome/pro-duotone-svg-icons';

// Import brand icons here
// import { faGithub as fabGithub } from '@fortawesome/free-brands-svg-icons';

export default function () {
  // Create icon library, add icons here after importing them above
  library.add(
    fadCow,
    fadSquareFull,
    fadCheckCircle
    // falLongArrowRight,
    // farMegaphone
    // fasSignIn,
    // fadHandsHelping,
    // fabGithub,
  );

  // Watch the DOM for UI changes to convert icons to svg on the fly
  dom.watch();

  // Register the icon component globaly
  Vue.component('Icon', FontAwesomeIcon);
}

// Use the component:
// <Icon :icon="['fas', 'sign-in']" />
